const SLOT_STATUSES = {
	CONFIRMED_SHIFT: 'CONFIRMED_SHIFT',
	FACILITY_CANCELLED: 'FACILITY_CANCELLED',
	UNABLE_TO_STAFF: 'UNABLE_TO_STAFF'
};

export default SLOT_STATUSES;
